<template>
    <div class="container-fluid">
        <Topbar />
        <div class="card shadow mx-3 conteudo text-left" style="margin-top: 90px">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary-dark">
                    <i :class="`${title.icon} mr-2`"></i>{{ title.text }}
                    <div v-show="carregando" class="spinner-grow">
                        <span class="sr-only">Loading...</span>
                    </div>
                </h6>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-12">
                        <fieldset v-if="isDataLoaded()" :disabled="carregando">
                            <Quadro :type="messageType" :message="message" />
                            <form>
                                <div class="d-print-none">
                                    <a @click="$router.go(-1)" id="btn_voltar" class="btn btn-secondary mr-1">
                                        <i class="fa fa-arrow-left"></i> Voltar
                                    </a>
                                    <button type="button" id="btnSave" class="btn btn-primary mr-1" @click="salvar">
                                        Salvar
                                    </button>
                                    <button
                                        v-if="operation == 'update'"
                                        type="button"
                                        id="btnReprocessar"
                                        class="btn btn-warning mr-1"
                                        @click="abrirModalReprocessar"
                                    >
                                        <i class="fas fa-sync-alt"></i> Reprocessar Cobranças
                                    </button>
                                    <button
                                        type="button"
                                        id="btn_del"
                                        class="btn btn-danger mr-1"
                                        :disabled="operation === 'insert'"
                                        data-toggle="modal"
                                        data-target="#modalExcluir"
                                    >
                                        Excluir
                                    </button>
                                    <hr />
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <fieldset>
                                            <div class="form-row">
                                                <InputAndLabel
                                                    column="1"
                                                    name="id"
                                                    label="ID"
                                                    type="text"
                                                    v-model="dados[idname].value"
                                                    readonly
                                                />
                                                <InputAndLabel
                                                    column="4"
                                                    name="nome"
                                                    label="Nome"
                                                    type="text"
                                                    maxlength="100"
                                                    v-model="dados.nome.value"
                                                    :errorMessage="errors.nome"
                                                />
                                                <InputAndLabel
                                                    column="2"
                                                    name="dataini"
                                                    label="Data Início"
                                                    type="date"
                                                    v-model="dados.dataini.value"
                                                    :errorMessage="errors.dataini"
                                                />
                                                <InputAndLabel
                                                    column="2"
                                                    name="datafim"
                                                    label="Data Fim"
                                                    type="date"
                                                    v-model="dados.datafim.value"
                                                    :errorMessage="errors.datafim"
                                                />
                                                <SelectAndLabel
                                                    column="3"
                                                    name="idtabcob"
                                                    label="Tabela de Cobrança"
                                                    :options="combos.idtabcob"
                                                    v-model="dados.idtabcob.value"
                                                    :errorMessage="errors.idtabcob"
                                                />
                                            </div>
                                            <div class="form-row">

                                                <SelectAndLabel
                                                    column="2"
                                                    name="idempresasfat"
                                                    label="Empresa Faturamento"
                                                    :options="combos.idempresasfat"
                                                    v-model="dados.idempresasfat.value"
                                                    :errorMessage="errors.idempresasfat"
                                                />
                                                <SelectAndLabel
                                                    column="2"
                                                    name="idclientescob"
                                                    label="Cliente Cobrança"
                                                    :options="combos.idclientescob"
                                                    v-model="dados.idclientescob.value"
                                                    :errorMessage="errors.idclientescob"
                                                />

                                                <div class="col-2">
                                                    <label for="cnpjEmpresa">CNPJ</label>
                                                    <input type="text" class="form-control" id="cnpjEmpresa" readonly>
                                                </div>
                            
                                                <SelectAndLabel
                                                    column="2"
                                                    name="idmodelocob"
                                                    label="Modelo"
                                                    :options="combos.idmodelocob"
                                                    v-model="dados.idmodelocob.value"
                                                    :errorMessage="errors.idmodelocob"
                                                />
                                                <InputAndLabel
                                                    column="2"
                                                    name="perc_fixo"
                                                    label="% Fixo"
                                                    type="number"
                                                    format="decimal"
                                                    min="0"
                                                    step="0.01"
                                                    v-model="dados.perc_fixo.value"
                                                    :errorMessage="errors.perc_fixo"
                                                    right
                                                />
                                                <InputAndLabel
                                                    column="2"
                                                    name="valor_fixo"
                                                    label="Valor Fixo"
                                                    type="number"
                                                    format="decimal"
                                                    min="0"
                                                    step="0.01"
                                                    v-model="dados.valor_fixo.value"
                                                    :errorMessage="errors.valor_fixo"
                                                    right
                                                />
                                            </div>
                                            <div class="form-row">
                                                <InputAndLabel
                                                    column="2"
                                                    name="valfatmin"
                                                    label="Valor Faturamento Min"
                                                    type="number"
                                                    format="decimal"
                                                    min="0"
                                                    step="0.01"
                                                    v-model="dados.valfatmin.value"
                                                    :errorMessage="errors.valfatmin"
                                                    right
                                                />
                                                <InputAndLabel
                                                    column="2"
                                                    name="valorreversa"
                                                    label="Valor Reversa"
                                                    format="decimal"
                                                    type="number"
                                                    min="0"
                                                    step="0.01"
                                                    v-model="dados.valorreversa.value"
                                                    :errorMessage="errors.valorreversa"
                                                    right
                                                />
                                                <InputAndLabel
                                                    column="2"
                                                    name="valoritensclass"
                                                    label="Valor Itens Class."
                                                    type="number"
                                                    format="decimal"
                                                    min="0"
                                                    step="0.01"
                                                    v-model="dados.valoritensclass.value"
                                                    :errorMessage="errors.valoritensclass"
                                                    right
                                                />
                                                <InputAndLabel
                                                    column="2"
                                                    name="perc_customedio"
                                                    label="% Custo Médio"
                                                    type="number"
                                                    format="decimal"
                                                    min="0"
                                                    step="0.01"
                                                    v-model="dados.perc_customedio.value"
                                                    :errorMessage="errors.perc_customedio"
                                                    right
                                                />
                                                <InputAndLabel
                                                    column="2"
                                                    name="mesesgiro"
                                                    label="Meses para composição de giro"
                                                    type="number"
                                                    format="integer"
                                                    min="0"
                                                    v-model="dados.mesesgiro.value"
                                                    :errorMessage="errors.mesesgiro"
                                                    right
                                                />
                                                <InputAndLabel
                                                    column="2"
                                                    name="giro"
                                                    label="Giro Estoque"
                                                    type="number"
                                                    format="integer"
                                                    min="0"
                                                    step="0.01"
                                                    v-model="dados.giro.value"
                                                    :errorMessage="errors.giro"
                                                    right
                                                />
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group pt-md-3 ml-md-3 ml-2">
                                                    <CheckboxAndLabel
                                                        name="cobmovflag"
                                                        v-model="dados.cobmovflag.value"
                                                        label="Cob. Movimento"
                                                        :errorMessage="errors.cobmovflag"
                                                    />
                                                </div>
                                                <div class="form-group pt-md-3 ml-md-3 ml-2">
                                                    <CheckboxAndLabel
                                                        name="cobfaturamentoflag"
                                                        v-model="dados.cobfaturamentoflag.value"
                                                        label="Cob. Faturamento"
                                                        :errorMessage="errors.cobfaturamentoflag"
                                                    />
                                                </div>
                                                <div class="form-group pt-md-3 ml-md-3 ml-2">
                                                    <CheckboxAndLabel
                                                        name="cobinsumo"
                                                        v-model="dados.cobinsumo.value"
                                                        label="Cob. Insumo"
                                                        :errorMessage="errors.cobinsumo"
                                                    />
                                                </div>
                                                <div class="form-group pt-md-3 ml-md-3 ml-2">
                                                    <CheckboxAndLabel
                                                        name="cobitensclass"
                                                        v-model="dados.cobitensclass.value"
                                                        label="Cob. Itens Classificados"
                                                        :errorMessage="errors.cobitensclass"
                                                    />
                                                </div>
                                                <div class="form-group pt-md-3 ml-md-3 ml-2">
                                                    <CheckboxAndLabel
                                                        name="cobexced"
                                                        v-model="dados.cobexced.value"
                                                        label="Cob. Excedente"
                                                        :errorMessage="errors.cobexced"
                                                    />
                                                </div>
                                                <div class="form-group pt-md-3 ml-md-3 ml-2">
                                                    <CheckboxAndLabel
                                                        name="cobreversa"
                                                        v-model="dados.cobreversa.value"
                                                        label="Cob. Reversa"
                                                        :errorMessage="errors.cobreversa"
                                                    />
                                                </div>
                                            </div>
                                            <hr />
                                        </fieldset>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="card shadow" v-if="operation == 'update'">
                                            <div class="card-header bg-secondary py-3">
                                                <h6 class="m-0 font-weight-bold text-white row">
                                                    <div class="align-self-center">
                                                        <i class="fas fa-user"></i> Cliente
                                                    </div>
                                                    <div v-show="carregando" class="spinner-grow">
                                                        <span class="sr-only">Loading...</span>
                                                    </div>
                                                </h6>
                                            </div>

                                            <div class="p-0 card-body">
                                                <div class="collapsed" id="cnpjCard">
                                                    <div class="card card-body bg-light pb-0 pt-2 px-3">
                                                        <div class="form-row align-items-center">
                                                            <SelectAndLabel
                                                                :column="9"
                                                                name="cnpj"
                                                                label="Novo Cliente"
                                                                v-model="cnpj"
                                                                :options="combos.cnpjs"
                                                                input
                                                            />

                                                            <div class="form-group col-md-3 pt-md-2">
                                                                <button
                                                                    type="button"
                                                                    class="btn btn-primary form-control mt-md-4"
                                                                    @click="postarCnpj"
                                                                    :disabled="cnpj.length < 1"
                                                                >
                                                                    Lançar
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12 table-responsive">
                                                    <table class="table table-sm table-striped table-bordered my-3">
                                                        <thead>
                                                            <tr style="white-space: nowrap">
                                                                <th></th>
                                                                <th>Cliente</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                v-for="line in dados.cnpjs"
                                                                :key="'cnpj-' + line.idcontratos_cnpj"
                                                            >
                                                                <td>
                                                                    <a
                                                                        data-toggle="tooltip"
                                                                        title="Excluir"
                                                                        class="text-danger"
                                                                        @click="
                                                                            () =>
                                                                                abrirModalDeleteCnpj(
                                                                                    line.idcontratos_cnpj
                                                                                )
                                                                        "
                                                                    >
                                                                        <i class="fas fa-trash-alt"></i>
                                                                    </a>
                                                                </td>
                                                                <td>{{ line.cnpj }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12" v-if="operation == 'insert'">
                                        <div class="card shadow mx-3 my-2 conteudo text-left">
                                            <div class="card-header">
                                                <div class="row">
                                                    <div class="col-10">
                                                        <h3 class="m-0">Contatos</h3>
                                                    </div>
                                                    <div class="col-2 text-right">
                                                        <a href="#" class="btn btn-sm btn btn-success" @click="dialogIncluirContato(true)">
                                                            Adcionar
                                                            <em class="fa fa-plus ml-2"></em>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body table-responsive">
                                                <table class="table table-striped table-bordered table-striped table-hover">
                                                    <thead>
                                                        <th style="width: 100px;">#</th>
                                                        <th style="width: 200px;">TIPO</th>
                                                        <th style="width: 300px;">VALOR</th>
                                                        <th>OBSERVAÇÃO</th>
                                                        <th class="text-center" style="width: 100px;">AÇÕES</th>
                                                    </thead>
                                                    <tbody>

                                                        <tr v-for="item in contatos_to_add" :key="item.id">
                                                            <td>{{ item.id }}</td>
                                                            <td>{{ item.tipo }}</td>
                                                            <td>{{ item.valor }}</td>
                                                            <td>{{ item.obs }}</td>
                                                            <td  v-if="!item.not_add" lass="text-center">
                                                                <a href="#" class="btn btn-sm btn-primary" @click="dialogAlterarContato(item, !item.not_add)">
                                                                    <em class="fa fa-edit"></em>
                                                                </a>
                                                                <a  href="#" class="btn btn-sm btn-danger ml-2" @click="excluirContatoTemporario(item.id)">
                                                                    <em class="fa fa-trash"></em>
                                                                </a>
                                                            </td>
                                                            <td  v-if="item.not_add" lass="text-center">
                                                                <a href="#" class="btn btn-sm btn-primary" @click="dialogAlterarContato(item, false)">
                                                                    <em class="fa fa-edit"></em>
                                                                </a>
                                                                <a  href="#" class="btn btn-sm btn-danger ml-2" @click="dialogExcluirContato(item)">
                                                                    <em class="fa fa-trash"></em>
                                                                </a>
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 mt-4 mt-lg-0">
                                        <div class="card shadow" v-if="operation == 'update'">
                                            <div class="card-header bg-secondary py-3">
                                                <h6 class="m-0 font-weight-bold text-white row">
                                                    <div class="align-self-center">
                                                        <i class="fas fa-user"></i> CNPJs Excludentes
                                                    </div>
                                                    <div v-show="carregando" class="spinner-grow">
                                                        <span class="sr-only">Loading...</span>
                                                    </div>
                                                </h6>
                                            </div>

                                            <div class="p-0 card-body">
                                                <div class="collapsed" id="cnpjCard">
                                                    <div class="card card-body bg-light pb-0 pt-2 px-3">
                                                        <div class="form-row align-items-center">
                                                            <InputAndLabel
                                                                :column="9"
                                                                name="cnpjex"
                                                                label="Novo CNPJ"
                                                                v-model="cnpjex"
                                                                v-mask="'##.###.###/####-##'"
                                                                type="text"
                                                            />

                                                            <div class="form-group col-md-3 pt-md-2">
                                                                <button
                                                                    type="button"
                                                                    class="btn btn-primary form-control mt-md-4"
                                                                    @click="postarCnpjEx"
                                                                    :disabled="cnpjex.length < 1"
                                                                >
                                                                    Lançar
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12 table-responsive">
                                                    <table class="table table-sm table-striped table-bordered my-3">
                                                        <thead>
                                                            <tr style="white-space: nowrap">
                                                                <th></th>
                                                                <th>CNPJs</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                v-for="line in dados.cnpjsex"
                                                                :key="'cnpj-' + line.idcontratos_cnpjex"
                                                            >
                                                                <td>
                                                                    <a
                                                                        data-toggle="tooltip"
                                                                        title="Excluir"
                                                                        class="text-danger"
                                                                        @click="
                                                                            () =>
                                                                                abrirModalDeleteCnpjEx(
                                                                                    line.idcontratos_cnpjex
                                                                                )
                                                                        "
                                                                    >
                                                                        <i class="fas fa-trash-alt"></i>
                                                                    </a>
                                                                </td>
                                                                <td>{{ maskCNPJCPF(line.cnpj) }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 mt-4">
                                        <div class="card shadow" v-if="operation == 'update'">
                                            <div class="card-header bg-secondary py-3">
                                                <h6 class="m-0 font-weight-bold text-white row">
                                                    <div class="align-self-center">
                                                        <i class="fas fa-phone"></i> Contatos Cliente
                                                    </div>
                                                    <div v-show="carregando" class="spinner-grow">
                                                        <span class="sr-only">Loading...</span>
                                                    </div>
                                                </h6>
                                            </div>

                                            <div class="p-0 card-body">
                                                <table class="table table-sm table-striped table-bordered my-3">
                                                    <thead>
                                                        <tr style="white-space: nowrap">
                                                            <th>
                                                                <button
                                                                    type="button"
                                                                    class="btn btn-primary"
                                                                    @click="() => dialogIncluirContato(false)"
                                                                >
                                                                    Lançar
                                                                </button>
                                                            </th>
                                                            <th>Tipo</th>
                                                            <th>Contato</th>
                                                            <th>Obsevação</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="item in contatos" :key="item.id">
                                                            <td>
                                                                 <a
                                                                        data-toggle="tooltip"
                                                                        title="Editar/Visualizar"
                                                                        class="text-primary"
                                                                        @click="
                                                                            () => dialogAlterarContato(item, false)
                                                                        "
                                                                    >
                                                                    <i class="fa fa-edit mr-2"></i>
                                                                </a>
                                                                <a
                                                                        data-toggle="tooltip"
                                                                        title="Excluir"
                                                                        class="text-danger"
                                                                        @click="
                                                                            () =>
                                                                                dialogExcluirContato(item)
                                                                        "
                                                                    >
                                                                    <i class="fas fa-trash-alt"></i>
                                                                </a>
                                                            </td>
                                                            <td>{{ item.tipo }}</td>
                                                            <td>{{ item.valor }}</td>
                                                            <td>{{ item.obs }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>
                                    </div>


                                    <div class="col-lg-6 mt-4">
                                        <div class="card shadow" v-if="operation == 'update'">
                                            <div class="card-header bg-secondary py-3">
                                                <h6 class="m-0 font-weight-bold text-white row">
                                                    <div class="align-self-center">
                                                        <i class="fas fa-exchange-alt"></i> Movimentos
                                                    </div>
                                                    <div v-show="carregando" class="spinner-grow">
                                                        <span class="sr-only">Loading...</span>
                                                    </div>
                                                </h6>
                                            </div>

                                            <div class="p-0 card-body">
                                                <div class="col-lg-12 table-responsive">
                                                    <table class="table table-sm table-striped table-bordered my-3">
                                                        <thead>
                                                            <tr style="white-space: nowrap">
                                                                <th>
                                                                    <button
                                                                        type="button"
                                                                        class="btn btn-primary"
                                                                        @click="() => abrirModalMov('insert')"
                                                                    >
                                                                        Lançar
                                                                    </button>
                                                                </th>
                                                                <th>Nome</th>
                                                                <th>Qtde Ped Início</th>
                                                                <th>Qtde Ped Fim</th>
                                                                <th>Valor Unidade</th>
                                                                <th>Valor Caixa</th>
                                                                <th>Valor Pedido</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                v-for="line in dados.movimentos"
                                                                :key="'movimento-' + line.idcontratos_mov"
                                                            >
                                                                <td>
                                                                    <a
                                                                        data-toggle="tooltip"
                                                                        title="Editar/Visualizar"
                                                                        class="text-primary"
                                                                        @click="
                                                                            () => abrirModalMov(line.idcontratos_mov)
                                                                        "
                                                                    >
                                                                        <i class="fa fa-edit mr-2"></i>
                                                                    </a>
                                                                    <a
                                                                        data-toggle="tooltip"
                                                                        title="Excluir"
                                                                        class="text-danger"
                                                                        @click="
                                                                            () =>
                                                                                abrirModalDeleteMov(
                                                                                    line.idcontratos_mov
                                                                                )
                                                                        "
                                                                    >
                                                                        <i class="fas fa-trash-alt"></i>
                                                                    </a>
                                                                </td>
                                                                <td
                                                                    v-if="line.nomeindex == 0"
                                                                    :rowspan="line.totalspan"
                                                                    class="text-center align-middle"
                                                                >
                                                                    {{ line.nome }}
                                                                </td>
                                                                <td>{{ line.qtdepedini }}</td>
                                                                <td>{{ line.qtdepedfim }}</td>
                                                                <td>{{ decimalFormat(line.valorunidade) }}</td>
                                                                <td>{{ decimalFormat(line.valorcaixa) }}</td>
                                                                <td>{{ decimalFormat(line.valorpedido) }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 mt-4">
                                        <div class="card shadow" v-if="operation == 'update'">
                                            <div class="card-header bg-secondary py-3">
                                                <h6 class="m-0 font-weight-bold text-white row">
                                                    <div class="align-self-center">
                                                        <i class="fas fa-warehouse"></i> Armazenamentos
                                                    </div>
                                                    <div v-show="carregando" class="spinner-grow">
                                                        <span class="sr-only">Loading...</span>
                                                    </div>
                                                </h6>
                                            </div>

                                            <div class="p-0 card-body">
                                                <div class="col-lg-12 table-responsive">
                                                    <table class="table table-sm table-striped table-bordered my-3">
                                                        <thead>
                                                            <tr style="white-space: nowrap">
                                                                <th>
                                                                    <button
                                                                        type="button"
                                                                        class="btn btn-primary"
                                                                        @click="() => abrirModalArm('insert')"
                                                                    >
                                                                        Lançar
                                                                    </button>
                                                                </th>
                                                                <th>Armazenamento</th>
                                                                <th class="text-right">Valor</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                v-for="line in dados.armazenamentos"
                                                                :key="'armazenamento-' + line.idcontratos_arm"
                                                            >
                                                                <td>
                                                                    <a
                                                                        data-toggle="tooltip"
                                                                        title="Editar/Visualizar"
                                                                        class="text-primary"
                                                                        @click="
                                                                            () => abrirModalArm(line.idcontratos_arm)
                                                                        "
                                                                    >
                                                                        <i class="fa fa-edit mr-2"></i>
                                                                    </a>
                                                                    <a
                                                                        data-toggle="tooltip"
                                                                        title="Excluir"
                                                                        class="text-danger"
                                                                        @click="
                                                                            () =>
                                                                                abrirModalDeleteArm(
                                                                                    line.idcontratos_arm
                                                                                )
                                                                        "
                                                                    >
                                                                        <i class="fas fa-trash-alt"></i>
                                                                    </a>
                                                                </td>
                                                                <td>{{ line.nome }}</td>
                                                                <td class="text-right">
                                                                    {{ decimalFormat(line.valor) }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 mt-4">
                                        <div class="card shadow" v-if="operation == 'update'">
                                            <div class="card-header bg-secondary py-3">
                                                <h6 class="m-0 font-weight-bold text-white row">
                                                    <div class="align-self-center">
                                                        <i class="fas fa-tags"></i> Ocorrências Fixas
                                                    </div>
                                                    <div v-show="carregando" class="spinner-grow">
                                                        <span class="sr-only">Loading...</span>
                                                    </div>
                                                </h6>
                                            </div>

                                            <div class="p-0 card-body">
                                                <div class="col-lg-12 table-responsive">
                                                    <table class="table table-sm table-striped table-bordered my-3">
                                                        <thead>
                                                            <tr style="white-space: nowrap">
                                                                <th>
                                                                    <button
                                                                        type="button"
                                                                        class="btn btn-primary"
                                                                        @click="() => abrirModalOcorrencia('insert')"
                                                                    >
                                                                        Lançar
                                                                    </button>
                                                                </th>
                                                                <th>Ocorrencia</th>
                                                                <th class="text-right">Qtde.</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                v-for="line in dados.ocorrencias.dados"
                                                                :key="'ocorrencia-' + line.idcontratos_ocorrencias"
                                                            >
                                                                <td>
                                                                    <a
                                                                        data-toggle="tooltip"
                                                                        title="Editar/Visualizar"
                                                                        class="text-primary"
                                                                        @click="
                                                                            () => abrirModalOcorrencia(line.idcontratos_ocorrencias)
                                                                        "
                                                                    >
                                                                        <i class="fa fa-edit mr-2"></i>
                                                                    </a>
                                                                    <a
                                                                        data-toggle="tooltip"
                                                                        title="Excluir"
                                                                        class="text-danger"
                                                                        @click="
                                                                            () =>
                                                                                abrirModalDeleteOcorrencia(line.idcontratos_ocorrencias)
                                                                        "
                                                                    >
                                                                        <i class="fas fa-trash-alt"></i>
                                                                    </a>
                                                                </td>
                                                                <td>{{ line.ocorrencia }}</td>
                                                                <td class="text-right">
                                                                    {{ decimalFormat(line.qtde) }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </fieldset>
                    </div>
                </div>
            </div>
        </div>
        <Modal
            v-if="operation == 'update'"
            id="modalReprocessar"
            title="Reprocessar"
            confirmClass="btn btn-primary"
            :confirmFunction="reprocessar"
            small
        >
            <div class="row text-left">
                <div class="col-lg-12">
                    <fieldset>
                        <div class="form-row">
                            <InputAndLabel
                                column="12"
                                name="dataReprocessar"
                                label="Data"
                                type="date"
                                v-model="dataReprocessar"
                            />
                        </div>
                    </fieldset>
                </div>
            </div>
        </Modal>
        <Modal
            v-if="operation == 'update'"
            id="modalMov"
            title="Movimento"
            confirmClass="btn btn-danger d-none"
            :confirmFunction="() => null"
            noFooter
        >
            <ContratoMov
                v-if="isDataLoaded()"
                :id="movSelecionada"
                :parentSetMovSelecionada="setMovSelecionada"
                :idparent="dados[idname].value"
                :parentBaseUrl="baseUrl"
                :parentGetData="getData"
            />
        </Modal>
        <Modal
            id="modalDeleteMov"
            title="Confirmar Exclusão"
            confirmClass="btn btn-danger"
            confirmText="Excluir"
            :confirmFunction="deleteMov"
        >
            Tem certeza que deseja excluir este movimento?
        </Modal>
        <Modal
            v-if="operation == 'update'"
            id="modalArm"
            title="Armazenamento"
            confirmClass="btn btn-danger d-none"
            :confirmFunction="() => null"
            noFooter
        >
            <ContratoArm
                v-if="isDataLoaded()"
                :id="armSelecionada"
                :parentSetArmSelecionada="setArmSelecionada"
                :idparent="dados[idname].value"
                :parentBaseUrl="baseUrl"
                :parentGetData="getData"
            />
        </Modal>
        <Modal
            v-if="operation == 'update'"
            id="modalOcorrencia"
            title="Ocorrencia"
            confirmClass="btn btn-danger d-none"
            :confirmFunction="() => null"
            noFooter
        >
            <ContratosOcorrencia
                v-if="isDataLoaded()"
                :id="ocorrenciaSelecionado"
                :parentsetOcorrenciaSelecionado="setOcorrenciaSelecionado"
                :idparent="dados[idname].value"
                :parentBaseUrl="baseUrl"
                :parentGetData="getData"
            />
        </Modal>
        <Modal
            id="modalDeleteArm"
            title="Confirmar Exclusão"
            confirmClass="btn btn-danger"
            confirmText="Excluir"
            :confirmFunction="deleteArm"
        >
            Tem certeza que deseja excluir este armazenamento?
        </Modal>
        <Modal
            id="modalDeleteCnpj"
            title="Confirmar Exclusão"
            confirmClass="btn btn-danger"
            confirmText="Excluir"
            :confirmFunction="deleteCnpj"
        >
            Tem certeza que deseja excluir este CNPJ?
        </Modal>
        <Modal
            id="modalDeleteCnpjEx"
            title="Confirmar Exclusão"
            confirmClass="btn btn-danger"
            confirmText="Excluir"
            :confirmFunction="deleteCnpjEx"
        >
            Tem certeza que deseja excluir este CNPJ?
        </Modal>
        <Modal
            id="modalExcluir"
            title="Confirmar Exclusão"
            confirmClass="btn btn-danger"
            confirmText="Excluir"
            :confirmFunction="deletar"
        >
            Tem certeza que deseja excluir este contrato?
        </Modal>
        <Modal
            id="modalDeleteOcorrencia"
            title="Confirmar Exclusão"
            confirmClass="btn btn-danger"
            confirmText="Excluir"
            :confirmFunction="deleteOcorrencia"
        >
            Tem certeza que deseja excluir este ocorrencia?
        </Modal>
        <ForbiddenModal />
        <LogoutModal />
        <Sidebar/>
    </div>
</template>

<script>
import api from "../services/api";
import Topbar from "@/components/Topbar";
import Sidebar from '@/components/Sidebar.vue';
import InputAndLabel from "@/components/InputAndLabel";
import SelectAndLabel from "@/components/SelectAndLabel";
import Quadro from "@/components/Quadro";
import LogoutModal from "@/components/LogoutModal.vue";
import Modal from "@/components/Modal";
import ViewMixin from "./ViewMixin";
import $ from "jquery";
import {
    ClientErrorException,
    DEFAULT_ERROR_MESSAGE,
    PermissaoException,
    ServerErrorException,
    TokenInvalidoException,
    ValidationException,
} from "../services/exceptions";
import ForbiddenModal from "../components/ForbiddenModal.vue";
import CheckboxAndLabel from "../components/CheckboxAndLabel.vue";
import ContratoArm from "../views/ContratoArm.vue";
import ContratoMov from "../views/ContratoMov.vue";
import ContratosOcorrencia from "../views/ContratosOcorrencia.vue";
import { getDate } from "../utils";
import Swal from 'sweetalert2'

export default {
    name: "Contrato",
    mixins: [ViewMixin],
    components: {
        Topbar,
        Sidebar,
        LogoutModal,
        Modal,
        InputAndLabel,
        SelectAndLabel,
        Quadro,
        ForbiddenModal,
        CheckboxAndLabel,
        ContratoArm,
        ContratoMov,
        ContratosOcorrencia,
    },
    props: ["id"],
    data: function () {
        return {
            idname: "idcontrato",
            baseUrl: "contratos",
            title: {
                icon: "fas fa-file-contract",
                text: "Contrato",
            },
            combos: {
                idcliente: [],
            },
            // dados: {
            //   documento: ''
            // },
            dataReprocessar: null,
            cnpj: "",
            cnpjex: "",
            idtipomov_val: "",
            idarm_val: "",
            idtamanho_val: "",
            armSelecionada: "insert",
            movSelecionada: "insert",
            modalDeleteCnpj: {
                id: "",
            },
            modalDeleteMovimento: {
                id: "",
            },
            modalDeleteTamanho: {
                id: "",
            },
            ocorrenciaSelecionado: "insert",
            contatos: [],
            contatos_to_add: [],
            idclientecob: null,
        };
    },
    beforeRouteLeave(to, from, next) {
        this.areYouSure(next);
    },
    mounted() {
        this.defineOperation(this.id);
        this.getCombo().then(this.getData);

        this.getContatos();
        this.selectCNPJ();

        setTimeout(() => {
            const vm = this;

            document.getElementById('idclientescob').addEventListener('change', function () {
                vm.getContatos();
                vm.selectCNPJ();
            });
        }, 2000);

    },
    methods: {
        async getCombo() {
            this.carregando = true;

            try {
                let response = await api.get(`/${this.baseUrl}/combosToSave/${this.id}`);
                let data = response.data;

                this.combos = data;

            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },

        selectCNPJ() {
            let empresaSelecionada = document.getElementById('idclientescob').value;

            for (const item of this.combos.idclientescob) {
                if (item.id == empresaSelecionada) {
                    this.idclientecob = item.id

                    this.getContatos();

                    let cnpj = item.cnpj;
                    cnpj = cnpj.toString().replace(/\D/g, '');

                    // Completa com zeros no final se tiver menos de 14 dígitos
                    cnpj = cnpj.padEnd(14, '0');

                    // Aplica a formatação: 00.000.000/0000-00
                    document.getElementById('cnpjEmpresa').value = cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, 
                                        '$1.$2.$3/$4-$5');
                }
            }
        },

        async getData(id = this.id) {
            this.carregando = true;
            
            try {
                let response = await api.get(`/${this.baseUrl}/${id}`);
                let data = response.data;
                this.setData(data, [
                    "idstatus",
                    "status",
                    "armazenamentos",
                    "tamanhos",
                    "movimentos",
                    "cnpjs",
                    "cnpjsex",
                    "ocorrencias",
                ]);
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },
        async salvar() {
        
            this.carregando = true;

            try {
                let response;
                let id =  this.operation === "update" ? this.dados[this.idname].value : null;
                let newData;
                let fieldsToDelete = [
                    "idstatus",
                    "status",
                    "armazenamentos",
                    "tamanhos",
                    "movimentos",
                    "cnpjs",
                    "cnpjsex",
                    "ocorrencias"
                ];

                if ($("#idempresasfat").val() === null || $("#idempresasfat").val() === "") {
                    this.setMessage("Informe a Empresa Faturamento", "danger");
                    this.carregando = false;
                    $("#idempresasfat").focus();
                    return;
                }

                if (this.operation === "update") {
                    newData = this.getDataToUpdate(fieldsToDelete);
                    response = await api.put(`/${this.baseUrl}/${id}`, newData);
                }

                if (this.contatos_to_add.length == 0) {
                    this.setMessage("Insira ao menos um contato!", "danger");
                    this.carregando = false;
                    return;
                }

                if (this.operation === "insert") {
                    newData = this.getDataToInsert(fieldsToDelete);
                    let contatos_to_insert = [];
                    for (const item of this.contatos_to_add) {

                        if (!item.not_add) {
                            contatos_to_insert.push(item);
                        }
                    }

                    newData["contatos"] = contatos_to_insert;
                    response = await api.post(`/${this.baseUrl}`, newData);
                }
                
                let data = response.data;
                id = data.id;

                if (this.operation === "update") {
                    this.dados[this.idname] = { value: id, oldValue: id };

                    this.operation = "update";
                    this.updateData(newData);
                }

                this.changeURL(`/${this.baseUrl}/${id}`);
                
                if (this.operation === "insert") {
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000);
                }

                this.setMessage(data.successMessage, "success");
                this.errors = {};
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },
        async reprocessar() {
            this.carregando = true;
            $("#modalReprocessar").modal("hide");

            try {
                let response;
                let id = this.dados[this.idname].value;
                response = await api.post(`/${this.baseUrl}/${id}/reprocessar`, { data: this.dataReprocessar });
                let data = response.data;

                this.setMessage(data.successMessage, "success");
                this.errors = {};
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
                console.error(e);
            }

            this.carregando = false;
        },
        async deletar() {
            this.carregando = true;

            $("#modalExcluir").modal("hide");

            try {
                let id = this.dados[this.idname].value;
                await api.delete(`/${this.baseUrl}/${id}`);

                this.$router.push(`/${this.baseUrl}`);
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },

        async postarCnpj() {
            this.carregando = true;
            $("#cnpjCard").collapse("hide");

            try {
                let response;
                let idcontrato = this.dados[this.idname].value;
                let cnpj = this.cnpj;
                response = await api.post(`/${this.baseUrl}/cnpj`, { idcontrato, cnpj });
                let dados = response.data;

                this.setMessage(dados.successMessage, "success");
                this.errors = {};
                this.cnpj = "";

                this.getData(idcontrato);
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },

        abrirModalReprocessar() {
            if (this.needConfirmToLeave) {
                if (confirm("Você tem alterações não salvas, salvar antes de editar?")) {
                    this.salvar();
                } else {
                    return null;
                }
            }
            (this.dataReprocessar = this.dataReprocessar ?? getDate("lastDayOfLastMonth"))
            $("#modalReprocessar").modal("show");
        },

        abrirModalDeleteCnpj(id) {
            this.modalDeleteCnpj.id = id;
            $("#modalDeleteCnpj").modal("show");
        },

        async deleteCnpj() {
            this.carregando = true;

            $("#modalDeleteCnpj").modal("hide");

            try {
                let id = this.modalDeleteCnpj.id;
                await api.delete(`/${this.baseUrl}/cnpj/${id}`);
                this.dados.cnpjs = this.dados.cnpjs.filter((el) => el.idcontratos_cnpj != id);
                this.getData();
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },

        async postarCnpjEx() {
            this.carregando = true;
            $("#cnpjCard").collapse("hide");

            try {
                let response;
                let idcontrato = this.dados[this.idname].value;
                let cnpj = this.cnpjex;
                response = await api.post(`/${this.baseUrl}/cnpjex`, { idcontrato, cnpj });
                let dados = response.data;

                this.setMessage(dados.successMessage, "success");
                this.errors = {};
                this.cnpjex = "";

                this.getData(idcontrato);
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },

        abrirModalDeleteCnpjEx(id) {
            this.modalDeleteCnpj.id = id;
            $("#modalDeleteCnpjEx").modal("show");
        },

        async deleteCnpjEx() {
            this.carregando = true;

            $("#modalDeleteCnpjEx").modal("hide");

            try {
                let id = this.modalDeleteCnpj.id;
                await api.delete(`/${this.baseUrl}/cnpjex/${id}`);
                this.getData();
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },

        setMovSelecionada(v) {
            this.movSelecionada = v;
        },

        abrirModalMov(id) {
            this.movSelecionada = id;
            $("#modalMov").modal("show");
        },

        abrirModalDeleteMov(id) {
            this.movSelecionada = id;
            $("#modalDeleteMov").modal("show");
        },

        async deleteMov() {
            this.carregando = true;

            $("#modalDeleteMov").modal("hide");

            try {
                let id = this.movSelecionada;
                await api.delete(`/${this.baseUrl}/${this.dados[this.idname].value}/mov/${id}`);
                this.dados.movimentos = this.dados.movimentos.filter((el) => el.idcontratos_mov != id);
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },

        setArmSelecionada(v) {
            this.armSelecionada = v;
        },

        abrirModalArm(id) {
            this.armSelecionada = id;
            $("#modalArm").modal("show");
        },

        abrirModalDeleteArm(id) {
            this.armSelecionada = id;
            $("#modalDeleteArm").modal("show");
        },

        async deleteArm() {
            this.carregando = true;

            $("#modalDeleteArm").modal("hide");

            try {
                let id = this.armSelecionada;
                await api.delete(`/${this.baseUrl}/${this.dados[this.idname].value}/arm/${id}`);
                this.dados.armazenamentos = this.dados.armazenamentos.filter((el) => el.idcontratos_arm != id);
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },

        abrirModalOcorrencia(id) {
            if (this.needConfirmToLeave) {
                if (confirm("Você tem alterações não salvas, salvar antes de editar?")) {
                    this.salvar();
                } else {
                    return null;
                }
            }
            this.ocorrenciaSelecionado = id;
            $("#modalOcorrencia").modal("show");
        },

        abrirModalDeleteOcorrencia(id) {
            this.ocorrenciaSelecionado = id;
            $("#modalDeleteOcorrencia").modal("show");
        },

        async deleteOcorrencia() {
            this.carregando = true;

            $("#modalDeleteOcorrencia").modal("hide");

            try {
                let id = this.ocorrenciaSelecionado;
                await api.delete(`/${this.baseUrl}/${this.dados[this.idname].value}/ocorrencia/${id}`);

                this.getData();
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
                console.error(e);
            }

            this.carregando = false;
        },

        setOcorrenciaSelecionado(v) {
            this.ocorrenciaSelecionado = v;
        },

        async getContatos() {

            this.carregando = true;

            try {
                let response = await api.get(`/clientescob/contatos/${this.id}`);
                this.contatos = response.data.contatos;

                let contatos_loaded = [];
                let contatos_backup = [];

                for (const item of this.contatos_to_add) {
                    if (!item.not_add) {
                        contatos_backup.push(item);
                    }
                }
                for (const item of this.contatos) {
                    item["not_add"] = true;
                    contatos_loaded.push(item);
                }

                for (const item of contatos_backup) {
                    contatos_loaded.push(item);
                }

                this.contatos_to_add = contatos_loaded;
            } catch (e) {
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
            }

            this.carregando = false;
        },

        dialogIncluirContato(temp=false) {

            let html  =`
                <div class="container text-left">
                    <h4 class="text-center">Incluir Contato</h4>
                    <br>
                    <div class="row">
                        <div class="col-12">
                            <label for="tipo">Tipo de Contato</label>
                            <select id="tipo" class="form-control">
                                <option value="">-- selecione o tipo do contato --</option>
                                <option value="email">Email</option>
                                <option value="telefone">Telefone</option>
                            </select>
                        </div>
                        <div class="col-12 mt-2">
                            <label for="valorContato">Contato</label>
                            <input type="text" class="form-control" id="valorContato" autocomplete="off" placeholder="Ex. email@email.com, 11 99999-9999">
                        </div>
                        <div class="col-12 mt-2">
                            <label for="obs">Observação</label>
                            <textarea class="form-control" rows="4" id="obs"></textarea>
                        </div>
                    </div>
                </div>
            `;

            Swal.fire({
                html: html,
                width: '450px',
                showCancelButton: true,
                confirmButtonText: 'Salvar',
                cancelButtonText: 'Cancelar',
                allowOutsideClick: false,
                preConfirm: () => {
                    const tipo = document.getElementById('tipo').value.trim();
                    const valor = document.getElementById('valorContato').value.trim();
                    const obs = document.getElementById('obs').value.trim();

                    if (!tipo || !valor || !obs) {
                        Swal.showValidationMessage('Todos os campos são obrigatórios!');
                        return false;
                    }

                    let objCreate = {
                        tipo: tipo,
                        valor: valor,
                        obs: obs,
                        idclientecontrato: this.id
                    };

                    if (temp) {
                        objCreate["id"] = "novo" + parseInt(this.contatos_to_add.length + 1);
                        objCreate["not_add"] = false;
                        this.contatos_to_add.push(objCreate);
                    } else {
                        this.incluirContato(objCreate);
                    }
                }
            });
        },

        async incluirContato(contato) {

            this.carregando = true;

            try {
                let response = await api.post(`/clientescob/contato`, contato);
                let message = response.data.successMessage;

                Swal.fire({
                    icon: 'success',
                    text: message,
                    timer: 3000
                });

                this.getContatos();
            } catch (e) {
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
            }

            this.carregando = false;
        },

        excluirContatoTemporario(id) {
            const objWithIdIndex = this.contatos_to_add.findIndex((obj) => obj.id === id);
            if (objWithIdIndex !== -1) {
                this.contatos_to_add.splice(objWithIdIndex, 1);
            }
        },

        dialogExcluirContato(contato) {

            Swal.fire({
                icon: 'question',
                text: `Deseja excluir o ${contato.tipo}: ${contato.valor}?`,
                showCancelButton: true,
                confirmButtonText: 'SIM',
                cancelButtonText: 'NÃO',
                allowOutsideClick: false,
                preConfirm: () => {
                    this.excluirContato(contato);
                }
            });
        },

        async excluirContato(contato) {
            this.carregando = true;

            try {
                let response = await api.delete(`/clientescob/contato/delete/${contato.id}`);
                let message = response.data.successMessage;

                Swal.fire({
                    icon: 'success',
                    text: message,
                    timer: 3000
                });

                this.getContatos();
            } catch (e) {
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
            }

            this.carregando = false;
        },

        dialogAlterarContato(contato, temp=false) {

            let html  =`
                <div class="container text-left">
                    <h4 class="text-center">Alterar Contato</h4>
                    <br>
                    <div class="row">
                        <div class="col-12">
                            <label for="tipo">Tipo de Contato</label>
                            <select id="tipo" class="form-control">
                                <option value="email" ${contato.tipo == 'email' ? 'selected' : ''}>Email</option>
                                <option value="telefone" ${contato.tipo == 'telefone' ? 'selected' : ''}>Telefone</option>
                            </select>
                        </div>
                        <div class="col-12 mt-2">
                            <label for="valorContato">Contato</label>
                            <input type="text" class="form-control" autocomplete="off" placeholder="Ex. email@email.com, 11 99999-9999" id="valorContato" value="${contato.valor}">
                        </div>
                        <div class="col-12 mt-2">
                            <label for="obs">Observação</label>
                            <textarea class="form-control" rows="4" id="obs">${contato.obs}</textarea>
                        </div>
                    </div>
                </div>
            `;

            Swal.fire({
                html: html,
                width: '450px',
                showCancelButton: true,
                confirmButtonText: 'Salvar',
                cancelButtonText: 'Cancelar',
                allowOutsideClick: false,
                preConfirm: () => {

                    const tipo = document.getElementById('tipo').value.trim();
                    const valor = document.getElementById('valorContato').value.trim();
                    const obs = document.getElementById('obs').value.trim();

                    if (!tipo || !valor || !obs) {
                        Swal.showValidationMessage('Todos os campos são obrigatórios!');
                        return false;
                    }

                    let objUpdate = {
                        id: contato.id,
                        tipo: tipo,
                        valor: valor,
                        obs: obs
                    };
                    
                    if (temp) {
                        for (const item of this.contatos_to_add) {
                            if (item.id == contato.id) {
                                item.tipo = tipo;
                                item.valor = valor;
                                item.obs = obs;
                                break;
                            }
                        }
                    } else {
                        this.alterarContato(objUpdate);
                    }
                }
            });
        },

        async alterarContato(contato) {

            this.carregando = true;

            try {
                let response = await api.put(`/clientescob/contato/save/${contato.id}`, contato);
                let message = response.data.successMessage;

                Swal.fire({
                    icon: 'success',
                    text: message,
                    timer: 3000
                });

                this.getContatos();
            } catch (e) {
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
            }

            this.carregando = false;
        },
    },

    watch: {
        "dados.documento.value": {
            handler: function (newVal, oldVal) {
                console.log(newVal, oldVal);
            },
        },
    },
};
</script>
